<template>
  <div class="home">
    这里是首页
  </div>
</template>

<script>

export default {
  name: 'Home',
}
</script>
